import UpdateAlert from './Alert';

export const components = {
    UpdateAlert,
  };
  